// import React from 'react';
// import { Card } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import Card from '../Card.js';

const SearchResult = ({update_p,personal}) => {
  const location = useLocation();
  const products = location.state?.products;

  return (
    <div className='p-5'>
      <div className='cards'>
        <div className='row'>
          {Array.isArray(products) && products.map((product, index) => (
            <div className="col-6 col-lg-3 mb-3 mb-lg-0" key={index}>
              <Card
                 ImageCard={
                    product?.images[0]?.secure_url &&
                    product.images[0]?.secure_url
                  }
                  update_p={update_p}
                  personal={personal}
                  brand={product.brand}
                  name={product.name}
                  price={product.price_after}
                  id={product._id}
                  rate={product.totalRate ? product.totalRate : 0}
                  new={false}
                  price_after={product.price_after}
                  price_before={product.price_before}
                  product={product}
                
              />
            </div>
          ))}
        </div>
      </div>
    </div> 
  );
};

export default SearchResult;